module.exports = __webpack_public_path__ + "static/media/14.3f3387fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/14.jpg
// module id = 584
// module chunks = 0